<form class="example-form w-100">
  <mat-form-field class="example-full-width w-100" appearance="outline" style="height:60px">
    <input *ngIf="options.length > 6" type="text" matInput [placeholder]="placeholder"
      [formControl]="searchControl" [matAutocomplete]="auto" [value]="getSelectedText()"
      style="font-size: 14px; font-family:  var(--primary-font-family); width: 100%;">
      <mat-select *ngIf="options.length <= 6" [multiple]="multiSelect" [(ngModel)]="selectedItems"
      [ngModelOptions]="{standalone: true}" (selectionChange)="handleSelection($event)">
      <mat-option *ngFor="let student of options; trackBy: trackById" [value]="student">
        <mat-checkbox *ngIf="multiSelect" [checked]="student.isChecked">
          {{student.name}}
        </mat-checkbox>
        <span *ngIf="!multiSelect">{{student.name}}</span>
      </mat-option>
    </mat-select>
  </mat-form-field>
  <mat-autocomplete *ngIf="options.length > 6" #auto="matAutocomplete">
    <mat-option *ngFor="let student of filteredOptions; trackBy: trackById" [value]="null"
      (click)="toggleSelection(student, $event)">

      <mat-checkbox *ngIf="multiSelect" [checked]="student.isChecked" (click)="$event.stopPropagation()"
        (change)="toggleSelection(student, $event)">
        {{ student.name }}
      </mat-checkbox>

      <span *ngIf="!multiSelect">{{ student.name}}</span>
    </mat-option>
  </mat-autocomplete>
</form>